import { render } from "./DesignationPage.vue?vue&type=template&id=1a7aaa4c"
import script from "./DesignationPage.vue?vue&type=script&lang=js"
export * from "./DesignationPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__